<div class="justify-content">
    <div class="flex-start">
        <h4 (click)="toggle()" (keyup.enter)="toggle()" class="btn btn-link no-padding btn-toggle reverse-toggle" [ngClass]="showContent ? 'link-toggle-hidden' : 'toggle-displayed'" value="Collapse section" role="button" tabindex="0" id="content-toggle" attr.aria-expanded="{{showContent}}">
            {{ title | translate}}
             <span class="toggle-icon">
                 <i class="fa fa-angle-right" aria-hidden="true"></i>
             </span>
        </h4>
    </div>
    <!-- <rl-search *ngIf="showSearch" (onSearch)="onSearch.emit($event)"></rl-search> -->
</div>
<ng-content *ngIf="showContent"></ng-content>